import { useEffect, useState } from "react";
import {  useAsyncEntity} from "@backstage/plugin-catalog-react";
import { InfoCard } from "@backstage/core-components";
import { identityApiRef, useApi } from "@backstage/core-plugin-api";
import axios from 'axios';
import Typography from '@material-ui/core/Typography';

export const EntityReleaseVersion = () => {

    const { entity, loading, error } = useAsyncEntity();
    const identityApi = useApi(identityApiRef);
  
    const [releaseVersion, setReleaseVersion] = useState('');
    const [releaseDateVersion, setReleaseDateVersion] = useState('');
    const [loadingVersion, setLoadingVersion] = useState(false);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoadingVersion(true);
          const credendials = await identityApi.getCredentials();
          const token = credendials.token ?? '';
  
          const response = await axios.get('/api/proxy/octopus-deploy/projects/'
            + entity?.metadata?.annotations!['octopus.com/project-id'] 
            + '/progression?releaseHistoryCount=3',
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
            );
          const data = response.data;
  
          const prodEnvironment : any = Object.values(data.LifecycleEnvironments).flat().find(
            (env: any) => {
              return env.Name === 'PROD';
            }
          );
  
          if (prodEnvironment) {
            const prodEnvironmentId = prodEnvironment.Id;
  
            const release = data.Releases.find((release: { Deployments: { [x: string]: any[]; }; }) =>
              release.Deployments[prodEnvironmentId]
               ? release.Deployments[prodEnvironmentId].some(
                    (deployment) => deployment.ReleaseVersion
                  )
                : false
            );
  
            if (release) {
              setReleaseVersion(
                release.Deployments[prodEnvironmentId].find((deployment: { ReleaseVersion: any; }) => deployment.ReleaseVersion).ReleaseVersion
              );
              setReleaseDateVersion(
                release.Deployments[prodEnvironmentId].find((deployment: { ReleaseVersion: any; }) => deployment.ReleaseVersion).CompletedTime
              );
            }
          }
          setLoadingVersion(false);
        } catch (error) {
            console.error("Error fetching data release version: " + error);
            setLoadingVersion(false);
            setReleaseVersion('');
        }
      };
  
      fetchData();
    }, []);
  
    if (loading) {
      return <div>Loading...</div>;
    }
  
    if (error) {
      return <div>Error: {error.message}</div>;
    }

    const date = new Date(releaseDateVersion);
    
    const timeFormat: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      
      const formattedDate = date.toLocaleString('en-US', timeFormat);

    return (
        <InfoCard title={'Version'}>
            <Typography variant="h5" >
                { loadingVersion ? 
                    'Loading...' 
                    : (releaseVersion != '' ? releaseVersion + ' - Release Date: ' + formattedDate : 'None in Prod') 
                }
            </Typography>
        </InfoCard>
    );
};
